import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { navLinks } from '../../data/mock';

const LOGO_URL = "/mldc-logo.jpg";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'py-2' : 'py-4'}`}>
      <div className="container mx-auto px-4">
        <div className="flex items-center gap-4">
          {/* Logo - Separate from nav */}
          <Link to="/" className="flex items-center">
            <img
              src={LOGO_URL}
              alt="MLDC Agro"
              className="h-[120px] w-auto !rounded-[15px] !opacity-[95%]" />

          </Link>

          {/* Navigation Bar - Compact pill, centered in remaining space */}
          <nav className={`mx-auto flex items-center gap-8 px-6 py-4 rounded-full transition-all duration-300 ${
          isScrolled ?
          'bg-[#1a3a2f] shadow-lg' :
          'bg-[#1a3a2f]/95 backdrop-blur-sm'}`
          }>
            {/* Desktop Navigation */}
            <div className="hidden lg:flex items-center gap-8">
              {navLinks.map((link) =>
              <Link
                key={link.path}
                to={link.path}
                className={`text-white font-medium transition-all duration-200 hover:text-[#D3FF62] ${
                location.pathname === link.path ? 'text-[#D3FF62]' : ''}`
                }>

                  {link.name}
                </Link>
              )}
            </div>

            {/* CTA Button - adjacent to Contact */}
            <Link
              to="/contact"
              className="hidden lg:block bg-[#D3FF62] text-[#004534] px-6 py-3 rounded-full font-semibold hover:bg-[#c4f050] transition-all duration-200 hover:-translate-y-0.5">

              Partner With Us
            </Link>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="lg:hidden text-white p-2"
              aria-label="Toggle menu">

              {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </nav>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen &&
        <div className="lg:hidden mt-2 bg-[#1a3a2f] rounded-3xl p-6 shadow-xl animate-in slide-in-from-top duration-300 ml-[140px]">
            <div className="flex flex-col gap-4">
              {navLinks.map((link) =>
            <Link
              key={link.path}
              to={link.path}
              onClick={() => setIsMenuOpen(false)}
              className={`text-white font-medium py-2 transition-colors hover:text-[#D3FF62] ${
              location.pathname === link.path ? 'text-[#D3FF62]' : ''}`
              }>

                  {link.name}
                </Link>
            )}
              <Link
              to="/contact"
              onClick={() => setIsMenuOpen(false)}
              className="bg-[#D3FF62] text-[#004534] px-6 py-3 rounded-full font-semibold text-center mt-2 hover:bg-[#c4f050] transition-all">

                Partner With Us
              </Link>
            </div>
          </div>
        }
      </div>
    </header>);

};

export default Header;